import { PageLayout } from '@/components/PageLayout/PageLayout';
import { AboutTeaserSection } from './sections/AboutTeaserSection';
import { ContactSection } from './sections/ContactSection';
import { DepartmentsSection } from './sections/DepartmentsSection';
import { HeroSection } from './sections/HeroSection';
import { ProcessSection } from './sections/ProcessSection';
import { WhoSection } from './sections/WhoSection';

export function HomePage() {
  return (
    <PageLayout revealHeaderOnScroll>
      <HeroSection />
      <WhoSection />
      <ProcessSection />
      <DepartmentsSection />
      <AboutTeaserSection />
      <ContactSection />
    </PageLayout>
  );
}
